import { createContext, Dispatch, SetStateAction } from 'react';
import { UIMessage } from 'ai';
import type { PersistedFeedbackStruct } from '@/api/types/workstation.types';

interface FeedbackHandlers {
  getAllFeedbackMessages: () => Record<string, PersistedFeedbackStruct>;
  getInMemoryFeedbackMessage: (messageId: string) => PersistedFeedbackStruct | undefined;
  addInMemoryFeedbackMessage: (messageId: string, feedback: PersistedFeedbackStruct) => void;
  removeInMemoryFeedbackMessage: (messageId: string) => void;
}

export interface ChatContextType {
  messages: UIMessage[];
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  input: string;
  setInput: (input: string) => void;
  setFoldersId: Dispatch<SetStateAction<string[]>>;
  foldersId: string[];
  isLoading: boolean;
  stop: () => void;
  chatId: string;
  handleNewChat: () => void;
  deepSearch: boolean;
  toggleDeepSearch: () => void;
  externalSearch: boolean;
  toggleExternalSearch: () => void;
  handleLoadChat: (messages: UIMessage[], id: string) => void;
  feedbackHandlers: FeedbackHandlers;
}

export const ChatContext = createContext<ChatContextType | undefined>(undefined); 
